import React, { useEffect, useState } from "react";
import { http } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const STATUSES = ["new", "qualified", "client", "archived"];

export default function AdminLeads() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    const r = await http.get("/admin/leads");
    setItems(r.data);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  async function setStatus(lead_id, status) {
    await http.patch(`/admin/leads/${lead_id}`, { status });
    await load();
  }

  return (
    <div data-testid="admin-leads">
      <h1 className="text-4xl">Leads</h1>
      <p className="mt-2 text-navy/65">All inquiries from the public site contact form.</p>

      <div className="mt-8">
        {loading ? (
          <div className="flex items-center gap-2 text-navy/60"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
        ) : items.length === 0 ? (
          <div className="card p-10 text-center"><p className="text-navy/65">No leads yet.</p></div>
        ) : (
          <div className="card overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-left text-xs uppercase tracking-widest text-navy/55 border-b border-navy/5">
                <tr>
                  <th className="px-5 py-4">Name</th>
                  <th className="px-5 py-4">Email</th>
                  <th className="px-5 py-4">Service</th>
                  <th className="px-5 py-4">Status</th>
                  <th className="px-5 py-4">Created</th>
                </tr>
              </thead>
              <tbody>
                {items.map((l) => (
                  <tr key={l.lead_id || l.id} className="border-b border-navy/5 last:border-0" data-testid={`lead-row-${l.lead_id || l.id}`}>
                    <td className="px-5 py-4 text-navy font-medium">{l.name}</td>
                    <td className="px-5 py-4 text-navy/70">{l.email}</td>
                    <td className="px-5 py-4 text-navy/70">{l.service || "—"}</td>
                    <td className="px-5 py-4">
                      <select
                        value={l.status || "new"}
                        onChange={(e) => setStatus(l.lead_id, e.target.value)}
                        data-testid={`lead-status-${l.lead_id}`}
                        className="bg-soft border border-navy/10 rounded-lg px-3 py-1.5 text-xs"
                      >
                        {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </td>
                    <td className="px-5 py-4 text-navy/60">{l.created_at?.slice(0, 10)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
